module.exports = __webpack_public_path__ + "static/img/companyBackground4.c6bfab89.png";